import api from "@/services/api"
import { queryClient } from "@/queryClient"
import { BASE_ORDERS_QUERY_KEY } from "./queryKeys"

type CreateSimplePaymentRequest = {
  note: string
  amountGross: number
  amountGratuity: number
}

export type CreateSimplePaymentResponse = {
  id: string
  invoice: {
    id: string
    amountGross: number
  }
}

export const createSimplePayment = async (
  params: CreateSimplePaymentRequest
): Promise<CreateSimplePaymentResponse> => {
  const response =
    await api.post<CreateSimplePaymentResponse>(
      "/orders/simple-payment/",
      {
        body: params,
      }
    )
  queryClient.invalidateQueries({
    queryKey: [BASE_ORDERS_QUERY_KEY],
  })
  return response.body
}
